import { useMediaQuery } from './useMediaQuery';

import variables from '../styles/_variables.scss';

export const useIsMobile = () => {
  const maxMobileWidth = parseInt(variables.screenWidthTablet, 10) - 1;
  return useMediaQuery(`(max-width: ${maxMobileWidth}px)`);
};
